import { useQuery } from "@tanstack/react-query";
import { trainerFilesApi } from "api/trainers/trainerFilesApi";
import { QUERIES_KEYS } from "queries";

export const useTrainerFileComments = (trainerId: number, fileId: number, enabled: boolean) => {
  return useQuery({
    queryKey: QUERIES_KEYS.TRAINER_FILE_COMMENTS(trainerId, fileId),
    queryFn: () => trainerFilesApi.fetchComments(trainerId, fileId),
    select: (res) => res.data,
    enabled,
  });
};
